/**
 * Determines whether a scroll event in the transcript should be treated
 * as user-initiated (and therefore pause the video).
 *
 * Returns true if the video should pause.
 */
export function shouldPauseOnScroll(
  isDragging: boolean,
  isInteractive: boolean,
  isPaused: boolean,
  autoScrollInFlight: boolean,
  lastProgrammaticScrollTop: number | null,
  currentScrollTop: number,
): boolean {
  if (isDragging || !isInteractive || isPaused) return false;

  // If an auto-scroll animation is scheduled/running, don't treat this as user scroll.
  // This covers the gap between cancelAutoScroll() and the first frame of a new animation,
  // where lastProgrammaticScrollTop is null but stale scroll events may still fire.
  if (autoScrollInFlight) return false;

  // Check if the scroll position matches what we programmatically set
  if (
    lastProgrammaticScrollTop !== null &&
    Math.abs(currentScrollTop - lastProgrammaticScrollTop) < 2
  ) {
    return false;
  }

  return true;
}
